import { render, staticRenderFns } from "./MyMedicalFile.vue?vue&type=template&id=60e60d46&scoped=true"
import script from "./MyMedicalFile.vue?vue&type=script&lang=js"
export * from "./MyMedicalFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e60d46",
  null
  
)

export default component.exports